import App from "./App"
import reportWebVitals from "./reportWebVitals"

import { ChakraProvider, ColorModeScript, extendTheme } from "@chakra-ui/react"
import React from "react"
import { createRoot } from "react-dom/client"

const themeConfig = {
  useSystemColorMode: true
}

const theme = extendTheme({ config: themeConfig })

const AppContainer = () => {
  return (
    <>
      <ColorModeScript />
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </>
  )
}

const root = createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
